module.exports = __webpack_public_path__ + "img/translationeditor_17.51c7f2f7.jpg";